import { PriceDealType } from 'shared/types/pricesTable';

export const PRICE_DEAL_TYPE_TABS: { value: PriceDealType; label: string }[] = [
  { value: PriceDealType.Sale, label: 'Продажа' },
  { value: PriceDealType.Rent, label: 'Аренда' },
];
